import styled from 'styled-components';
import { Text } from '@zillow/constellation';

export const Legend = styled(Text)`
  margin-left: 80px;
`;
